/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  AppInstallationsControllerCreateMutationResponse,
  AppInstallationsControllerCreate401,
} from '../types/AppInstallationsControllerCreate.ts';

function getAppInstallationsCreateUrl() {
  const res = { method: 'POST', url: `/api/app-installations` as const };
  return res;
}

/**
 * {@link /api/app-installations}
 */
export async function appInstallationsCreate(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    AppInstallationsControllerCreateMutationResponse,
    ResponseErrorConfig<AppInstallationsControllerCreate401>,
    unknown
  >({ method: 'POST', url: getAppInstallationsCreateUrl().url.toString(), ...requestConfig });
  return res.data;
}
